import { REACT_APP_API_GATEWAY_BASE_URL } from 'shared/config/config';
import { serialize } from 'shared/helpers';

import BaseService from 'services/baseService';

const apiGatetWayGeneralProxyApi = new BaseService(REACT_APP_API_GATEWAY_BASE_URL);

export const numberDetailsAPI = {
	getMaxPricingEnrollment(metaWabaId) {
		return apiGatetWayGeneralProxyApi.getRequest(
			serialize({ targetApi: 'getMaxPricingEnrollment', replaceable_params: { metaWabaId } }, '?')
		);
	},
	refreshMaxPricingDetails(metaWabaId) {
		return apiGatetWayGeneralProxyApi.postRequest(
			{},
			serialize({ targetApi: 'refreshMaxPricingDetails', replaceable_params: { metaWabaId } }, '?')
		);
	},
	optInMaxPricing(metaWabaId) {
		return apiGatetWayGeneralProxyApi.postRequest(
			{},
			serialize({ targetApi: 'optInMaxPricing', replaceable_params: { metaWabaId } }, '?')
		);
	},
	sendMaxPricingOptInEmail(contactUsSupportEmail, customerEmail) {
		return apiGatetWayGeneralProxyApi.postRequest(
			{ contactUsSupportEmail, customerEmail },
			serialize({ targetApi: 'sendMaxPricingOptInEmail' }, '?')
		);
	},
	getPhoneNumberDetails(customerId, appId) {
		const params = {
			targetApi: 'getPhoneNumberDetails',
			customerId,
			appId,
		};

		return apiGatetWayGeneralProxyApi.getRequest(serialize(params, '?'));
	},
	getWhatsAppCallingDetails(customerId, appId, platform) {
		const params = {
			targetApi: 'getWhatsAppCallingDetails',
			customerId,
			appId,
			platform,
		};

		return apiGatetWayGeneralProxyApi.getRequest(serialize(params, '?'));
	},
	getSolutionIdForCustomer(customerId) {
		const params = {
			targetApi: 'getSolutionIdForCustomer',
			customerId,
		};

		return apiGatetWayGeneralProxyApi.getRequest(serialize(params, '?'));
	},
	getWhatsappConfiguredBots() {
		const params = {
			targetApi: 'getWhatsappConfiguredBots',
		};

		return apiGatetWayGeneralProxyApi.getRequest(serialize(params, '?'));
	},
	getDialog360Details(phoneNumber, customerId, phoneNumberId) {
		const params = {
			targetApi: 'getDialog360Details',
			customerId,
			phoneNumber,
			phoneNumberId,
		};

		return apiGatetWayGeneralProxyApi.getRequest(serialize(params, '?'));
	},
	requestDialog360ChannelCancellation(phoneNumber) {
		return apiGatetWayGeneralProxyApi.postRequest(
			{ phoneNumber },
			serialize({ targetApi: 'requestDialog360ChannelCancellation' }, '?')
		);
	},
	getWhatsappLicenses(customerId) {
		const params = {
			targetApi: 'getWhatsappLicenses',
			customerId,
		};

		return apiGatetWayGeneralProxyApi.getRequest(serialize(params, '?'));
	},
	deployWhatsapp(dialog360DeploymentRequest, botRef) {
		const params = {
			targetApi: 'deployWhatsapp',
			botRef,
		};

		return apiGatetWayGeneralProxyApi.postRequest(dialog360DeploymentRequest, serialize(params, '?'));
	},
	checkNumberDeploymentStatus(platform) {
		const params = {
			targetApi: 'checkNumberDeploymentStatus',
			platform,
		};

		return apiGatetWayGeneralProxyApi.getRequest(serialize(params, '?'));
	},
	logoutFbAccount() {
		const params = {
			targetApi: 'deleteMetaAccessToken',
		};

		return apiGatetWayGeneralProxyApi.deleteRequest(serialize(params, '?'));
	},
	registerMetaPhoneNumber(phoneNumberId, wabaId) {
		const params = {
			targetApi: 'registerMetaPhoneNumber',
			phoneNumberId,
			wabaId,
		};

		return apiGatetWayGeneralProxyApi.postRequest({}, serialize(params, '?'));
	},
	verifyOnboardingStatus(wabaId, phoneNumberId, phoneNumber) {
		const params = {
			targetApi: 'verifyOnboardingStatus',
		};
		const payload = { wabaId, phoneNumberId, phoneNumber };

		return apiGatetWayGeneralProxyApi.postRequest(payload, serialize(params, '?'));
	},
	requestPhoneVerificationCode(phoneNumberId, payload) {
		const params = {
			targetApi: 'requestPhoneVerificationCode',
			replaceable_params: {
				phoneNumberId,
			},
		};

		return apiGatetWayGeneralProxyApi.postRequest(payload, serialize(params, '?'));
	},
	verifyPhoneVerificationCode(phoneNumberId, payload) {
		const params = {
			targetApi: 'verifyPhoneVerificationCode',
			replaceable_params: {
				phoneNumberId,
			},
		};

		return apiGatetWayGeneralProxyApi.postRequest(payload, serialize(params, '?'));
	},
	migrateTemplates(sourceWabaId, destinationWabaId, systemUserToken) {
		const params = {
			targetApi: 'migrateTemplates',
		};
		const payload = { sourceWabaId, destinationWabaId, systemUserToken };

		return apiGatetWayGeneralProxyApi.postRequest(payload, serialize(params, '?'));
	},
	migrateFlows(sourceWabaId, destinationWabaId, systemUserToken) {
		const params = {
			targetApi: 'migrateFlows',
		};
		const payload = { sourceWabaId, destinationWabaId, systemUserToken };

		return apiGatetWayGeneralProxyApi.postRequest(payload, serialize(params, '?'));
	},
	compareTemplateCategories(oldWabaId, newWabaId, systemUserToken) {
		const params = {
			targetApi: 'compareTemplateCategories',
		};
		const payload = { oldWabaId, newWabaId, systemUserToken };

		return apiGatetWayGeneralProxyApi.postRequest(payload, serialize(params, '?'));
	},
	migrate360DialogApis(bspToken) {
		const params = {
			targetApi: 'migrate360DialogApis',
		};
		const payload = { bspToken };

		return apiGatetWayGeneralProxyApi.postRequest(payload, serialize(params, '?'));
	},
	remapMigratedFlowIds(migratedFlows) {
		const params = {
			targetApi: 'remapMigratedFlowIds',
		};
		const payload = { migratedFlows };

		return apiGatetWayGeneralProxyApi.postRequest(payload, serialize(params, '?'));
	},
	undeployWhatsappManager(data) {
		const params = {
			targetApi: 'undeployWhatsappManager',
		};

		return apiGatetWayGeneralProxyApi.postRequest(data, serialize(params, '?'));
	},
	updateCallSettings(data, params) {
		return apiGatetWayGeneralProxyApi.postRequest(data, serialize(params, '?'));
	},
};
